import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AdminService } from '../../core/models/admin.models';

@Component({
  selector: 'app-service-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './service-form.component.html'
})
export class ServiceFormComponent implements OnInit {
  @Input() serviceData: AdminService | null = null;
  @Output() save = new EventEmitter<Partial<AdminService>>();
  @Output() cancel = new EventEmitter<void>();

  form!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.form = this.fb.group({
      name: [this.serviceData?.name || '', Validators.required],
      slug: [this.serviceData?.slug || '', Validators.required],
      category: [this.serviceData?.category || '', Validators.required],
      description: [this.serviceData?.description || ''],
      base_price: [this.serviceData?.base_price || 0, [Validators.required, Validators.min(0)]],
      estimated_duration_minutes: [this.serviceData?.estimated_duration_minutes || 60, [Validators.required, Validators.min(1)]],
      is_active: [this.serviceData?.is_active ?? true]
    });
  }

  submit() {
    if (this.form.valid) {
      this.save.emit(this.form.value);
    } else {
      this.form.markAllAsTouched();
    }
  }
}
